<template>
  <div id="contain">
    <Header :title = 'title'></Header>
    <div id="main">
      <flow-information :warningdetails = "warningdetails"></flow-information>
      <flow-chart :warningdetails = "warningdetails"></flow-chart>
    </div>
    <Footer/>
  </div>
</template>

<script>
import Header from '../../components/Header.vue'
import FlowChart from '../../components/FlowChart'
import Footer from '../../components/Footer'
import FlowInformation from '../../components/FlowInformation'
import { getAlarmDetail } from '../../api/earlydisposal' // getReadState
export default {
  components: {
    FlowChart,
    FlowInformation,
    Footer,
    Header
  },
  data(){
    return{
      title: '预警处置',
      warningdetails: '', // 预警处置基本信息
    }
  },
  created(){
    getAlarmDetail({
      url: '/alarm/info',
      data: {
        alarm_id: this.$route.params.id
      }
    }).then(res => {
      if (res !== null) {
        console.log(res)
        this.warningdetails = res.data.data
        console.log('预警处置', res, 'res.data.data', res.data.data)
      }
    })
  }
}

</script>

<style lang='scss' scoped>
  #contain{
    height: 100%;
    display: flex;
    flex-direction:column;
    #main{
      background-color: #F0F0F0;
      flex: 1;
      display: flex;
      box-sizing: border-box;
      flex-direction: column;
      align-items: center;
      overflow: auto;
      ::-webkit-scrollbar {
          width: 0px;
      }
    }
  }
</style>
